export default __webpack_public_path__ + "static/media/icon-algohealth-n.d9be7f0c.webp";